module.exports = __webpack_public_path__ + "img/jingyan1.dbd7fb59.png";